<template>
  	<el-container>
		<app-sidebar></app-sidebar>
		<el-container direction="vertical">
			<app-navbar></app-navbar>
			<app-content></app-content>
		</el-container>
	</el-container>
</template>

<script>
import { FECTH_DASHBOARD, FECTH_AUTH } from "@/store/actions.type";

import SideBar from "@/components/CloudAdmin/Sidebar";
import TopNavbar from "@/components/Dashboard/TopNavbar";
import DashboardContent from "@/components/Dashboard/Content.vue";

export default {
	name: "CloudAdmin",
	created() {
		this.user();
	},
	components: {
		"app-sidebar": SideBar,
		"app-navbar": TopNavbar,
		"app-content": DashboardContent,
	},
	methods: {
		user() {
			let obj = JSON.parse(localStorage.getItem("user"));
			this.$store.dispatch(FECTH_AUTH, obj);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/pages/CloudAdmin.vue